import { useState } from 'react';
import { Heading, Icon, Paragraph, Popover, Spacer, Table, Text, TextButton } from '@zillow/constellation-10';
import { IconInfoFilled } from '@zillow/constellation-icons';
import {
  applicationManagerTableHeaders,
  transferRequirements,
  useRentalManagerUser,
} from '@zg-rentals/rental-manager-env';
import { PermissionTransferModal } from '../../modal/PermissionTransferModal';
import {
  applicationManagerTableStyles,
  applicationPermissionsTableStyles,
  infoIconContainerStyles,
  infoIconStyles,
} from './StyledComponents';
import { useApplicationPermissions } from '../../hooks/useApplicationPermissions';

// Tooltip content migrated inline below

// Tooltip content migrated inline below

const ApplicationManager = () => {
  const { applicationManager, companyAdmins } = useApplicationPermissions();
  const { user } = useRentalManagerUser();
  const [showPermissionTransferModal, setShowPermissionTransferModal] = useState(false);

  const onTransferClick = () => {
    setShowPermissionTransferModal(true);
  };

  const isApplicationManager = applicationManager?.userToken === user.userToken;

  return (
    <>
      <div>
        <Text textStyle="heading-xs" asChild>
          <p>Application manager</p>
        </Text>
        <Text asChild>
          <p>
            The application manager is the only user on the account who can assign up to 5 other users permission access
            to applications.
            <Popover
              header={<Heading level={6}>Need help?</Heading>}
              body={
                <Paragraph>
                  If you want to take this role, please ask your application manager to trasfer it. If they are no
                  longer with your company, contact Zillow customer support.
                </Paragraph>
              }
              placement="top"
              trigger={
                <span className={infoIconContainerStyles}>
                  <Icon render={<IconInfoFilled />} className={infoIconStyles} css={{ color: 'blue600' }} />
                </span>
              }
            />
          </p>
        </Text>
        <Spacer css={{ paddingInline: 'sm' }}>
          <Table.Responsive>
            <Table.Root
              className={`${applicationManagerTableStyles} ${applicationPermissionsTableStyles}`}
              appearance="bare"
              aria-label="Application manager details table"
            >
              <Table.Header>
                <Table.Row>
                  {applicationManagerTableHeaders.map((header) => (
                    <Table.HeaderCell key={header}>{header}</Table.HeaderCell>
                  ))}
                </Table.Row>
              </Table.Header>
              <Table.Body>
                <Table.Row>
                  <Table.Cell>
                    {/* {applicationManager?.name && (
                      <Text textStyle="heading-xs" asChild>
                        <p>{applicationManager?.name}</p>
                      </Text>
                    )} */}
                    <Text asChild>
                      <p>{applicationManager?.userEmail}</p>
                    </Text>
                  </Table.Cell>
                  <Table.Cell>{applicationManager?.userManagementRoleString}</Table.Cell>
                  <Table.Cell>
                    <TextButton
                      onClick={onTransferClick}
                      disabled={!isApplicationManager || !companyAdmins.length}
                      type="button"
                    >
                      Transfer
                    </TextButton>
                    {!companyAdmins.length && (
                      <Popover
                        header={<Heading level={6}>Why is transfer unavailable?</Heading>}
                        body={<Paragraph>{transferRequirements}</Paragraph>}
                        placement="top"
                        trigger={
                          // @ts-ignore
                          <span className={infoIconContainerStyles}>
                            <Icon
                              render={<IconInfoFilled />}
                              className={infoIconStyles}
                              css={{ color: 'blue600' }}
                              size="sm"
                            />
                          </span>
                        }
                      />
                    )}
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table.Root>
          </Table.Responsive>
        </Spacer>
      </div>
      {showPermissionTransferModal && (
        <PermissionTransferModal setShowPermissionTransferModal={setShowPermissionTransferModal} />
      )}
    </>
  );
};

export default ApplicationManager;
